import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {AuthenticationState} from '../../store/state';
import {SignUpAction} from '../../store/authentication-actions';
import {ToastOptions, ToastyConfig, ToastyService} from 'ng2-toasty';

@Component({
  selector: 'app-register-component',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  group: FormGroup;
  constructor(private store: Store<any>, private toastService: ToastyService,
              toastyConfig: ToastyConfig) {
    toastyConfig.theme = 'bootstrap';
  }

  ngOnInit() {
    this.group = new FormGroup({
      email : new FormControl('', [Validators.required, Validators.email]),
      displayName: new FormControl('', [Validators.required]),
      password : new FormControl('', [Validators.required]),
      passwordConfirmation : new FormControl('', [Validators.required, ]),
    }, {validators: passwordMatch});

    this.store.select(state => state.auth.signUpError).subscribe(( error ) => {
      console.log('toasting ', error);
      if (error.length) {
        this.toastService.error({
          title: 'Error signing up',
          msg: error,
          timeout: 2000
        });
      }

    });
  }

  passwordValid(): boolean {
    return this.group.controls.password.touched && this.group.controls.password.dirty
      && this.group.controls.password.errors && this.group.controls.password.errors.required;
  }

  submit() {
    console.log(this.group);
    if ( this.group.invalid ) {
      this.group.markAsTouched();
      (Object as any).values(this.group.controls).forEach(control => {
        control.markAsTouched();
        control.markAsDirty();
      });

      console.log('form is invalid');
    } else {
      this.store.dispatch(new SignUpAction(
        {email: this.group.controls.email.value,
          displayName: this.group.controls.displayName.value,
          password: this.group.controls.password.value})
      );
    }
  }

  emailRequired(): boolean {
    return this.group.controls.email.touched && this.group.controls.email.dirty
      && this.group.controls.email.errors && this.group.controls.email.errors.required;
  }

  displayNameRequired() {
    return this.group.controls.displayName.touched && this.group.controls.displayName.dirty
      && this.group.controls.displayName.errors && this.group.controls.displayName.errors.required;
  }

  emailIsEmail(): boolean {
    return this.group.controls.email.touched && this.group.controls.email.dirty
      && this.group.controls.email.errors && this.group.controls.email.errors.email;
  }

  emailMatched(): boolean {
    return this.touched(this.group.controls.passwordConfirmation ) && (this.group.errors != null ||
      this.group.controls.passwordConfirmation.errors != null ) ;
   }

   touched( control: AbstractControl ): boolean {
    return  (control.touched && control.dirty);
  }
}

function passwordMatch(formGroup: FormGroup): ValidationErrors | null {
  const password = formGroup.controls.password.value;
  const confirmPassword = formGroup.controls.passwordConfirmation.value;
  if (password === confirmPassword) {
    return null;
  } else {
    return {
      passwordsMatched: true
    };
  }
}
